<script setup>
import { useI18n } from 'vue-i18n';
import LaisErrorState from 'dashboard/components-next/LaisErrorState.vue';

defineEmits(['back']);
const { t } = useI18n();
</script>

<template>
  <LaisErrorState
    status="403"
    icon="i-lucide-lock"
    :title="t('SALES.COMMISSION.FORBIDDEN.TITLE')"
    :description="t('SALES.COMMISSION.FORBIDDEN.DESCRIPTION')"
    :action-label="t('SALES.COMMISSION.FORBIDDEN.BACK')"
    action-icon="i-lucide-arrow-left"
    @action="$emit('back')"
  />
</template>
